import React from 'react';
import Hero from '../components/home/Hero';
import Products from '../components/home/Products';

const Home = () => {
    return (
        <div>
            <Hero />
            <Products />
        </div>
    );
};

export default Home;